import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-semibold text-white" }

import { Handle, NodeProps, Position } from '@vue-flow/core';
import { computed } from 'vue';

interface LinkStepProps {
  id: string;
  content: string;
  workflowCode: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkStep',
  props: {
    id: {},
    type: {},
    selected: { type: Boolean },
    connectable: { type: [Boolean, Number, String, Function] },
    position: {},
    dimensions: {},
    label: {},
    isValidTargetPos: { type: Function },
    isValidSourcePos: { type: Function },
    parent: {},
    parentNodeId: {},
    dragging: { type: Boolean },
    resizing: { type: Boolean },
    zIndex: {},
    targetPosition: {},
    sourcePosition: {},
    dragHandle: {},
    data: {},
    events: {}
  },
  setup(__props: any) {

const blueOrOrange = computed(() => {
  return props.data.workflowCode === '#DEFAULT' ? 'bg-blue-400' : 'bg-orange-400';
});

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_link, {
      to: encodeURIComponent(props.data.workflowCode)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["w-60 h-16 rounded-3xl flex justify-center items-center px-1", blueOrOrange.value])
        }, [
          _createElementVNode("p", _hoisted_1, _toDisplayString(props.data.content), 1)
        ], 2)
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_L`,
      type: "target",
      position: _unref(Position).Left
    }, null, 8, ["id", "position"])
  ], 64))
}
}

})